import { useRouter } from "next/router";

import { useCallback } from "react";

import { Insight } from "models/insight";
import { twMerge } from "tailwind-merge";

import { faComments } from "@fortawesome/free-regular-svg-icons";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons/faCaretDown";

import FontAwesomeIcon from "components/FontAwesomeIcon";
import useActivityTracker from "hooks/useActivityTracker";
import { useGlobalState } from "hooks/useGlobalState";
import { emberAppBaseUrl } from "utils/envVariables";

const ComposeButton = ({
  children,
  className,
  forkFrom,
  withDropDown,
}: {
  children?: React.ReactNode;
  className?: string;
  forkFrom?: Insight;
  withDropDown?: boolean;
}) => {
  const router = useRouter();
  const { trackEvent } = useActivityTracker();

  const [_showDiscussionComposeModal, setShowDiscussionComposeModal] =
    useGlobalState("showDiscussionComposeModal", false);

  const compose = useCallback(() => {
    trackEvent(forkFrom ? "Fork" : "Compose Insight", {});
    let url = `${emberAppBaseUrl}/compose/insight/in-depth`;
    if (forkFrom) {
      url += `?forked-from=${forkFrom.id}`;
    }
    router.push(url);
  }, [forkFrom, router, trackEvent]);

  if (children)
    return (
      <div className={className} onClick={compose}>
        {children}
      </div>
    );

  return (
    <button
      className={twMerge(
        "bg-white border-none rounded-full text-[13px] hover:font-medium hover:text-active-black",
        "mx-[12.5px] p-0",
        className
      )}
    >
      <span
        className={twMerge("pl-[16px]", !withDropDown && "pr-16px", "py-[6px]")}
        onClick={compose}
      >
        Compose
      </span>
      {withDropDown && (
        <div
          className={twMerge(
            "inline-block relative group ml-[10px] pl-[6px] pr-[8px] py-[5px]",
            "border-0 border-l-[2px] border-solid border-jade"
          )}
        >
          <FontAwesomeIcon
            icon={faCaretDown}
            className="inline-block !text-active-black !text-[13px] !min-w-0"
          />
          <div
            className={twMerge(
              "absolute hidden group-hover:block",
              "left-[-85px] w-[155px]",
              "pt-[10px]"
            )}
          >
            <div
              className={twMerge(
                "bg-white",
                "py-[5px]",
                "shadow",
                "rounded-lg"
              )}
            >
              <div
                className="cursor-pointer px-[10px] py-[5px] hover:bg-[rgba(36,169,167,0.3)]"
                onClick={() => router.push("/dashboard?collection=workspace")}
              >
                Drafts
              </div>
              <div
                className="cursor-pointer px-[10px] py-[5px] hover:bg-[rgba(36,169,167,0.3)]"
                onClick={() =>
                  router.push("/dashboard?collection=workspace&type=scheduled")
                }
              >
                Scheduled
              </div>
              <div
                className={twMerge(
                  "cursor-pointer px-[10px] py-[5px] hover:bg-[rgba(36,169,167,0.3)]",
                  "flex items-center border-0 border-t border-solid border-inactive-gray"
                )}
                onClick={() => setShowDiscussionComposeModal(true)}
              >
                <FontAwesomeIcon
                  icon={faComments}
                  className="!text-subtle-black !text-[15px] ml-[-5px]"
                />
                <span className="ml-[-13px]">Discussions</span>
              </div>
            </div>
          </div>
        </div>
      )}
    </button>
  );
};

export default ComposeButton;
